import { collection, getDocs } from 'firebase/firestore';
import { firestore } from '../database/firebase';
import { normalizeRoleName } from '../utils/roleResolver';

export async function listAllPeople({ includeClients = true } = {}) {
  const people = new Map();

  const add = (doc, roleHint) => {
    const data = doc.data?.() || doc.data || {};
    const email = String(data.email || '').toLowerCase();
    if (!email) return;
    const name = data.name || `${data.firstname || ''} ${data.lastname || ''}`.trim();
    const uid = data.uid || data.id || null;
    const role = normalizeRoleName(data.role || roleHint || 'Client');
    const existing = people.get(email) || { email, name, uid, roles: new Set(), raw: {} };
    existing.name = existing.name || name;
    existing.uid = existing.uid || uid;
    existing.roles.add(role);
    existing.raw = { ...existing.raw, ...data };
    people.set(email, existing);
  };

  const tasks = [];
  tasks.push(
    getDocs(collection(firestore, 'admin')).then(s => s.docs.forEach(d => add(d, 'Admin')))
  );
  tasks.push(
    getDocs(collection(firestore, 'moderator')).then(s => s.docs.forEach(d => add(d, 'Moderator')))
  );
  tasks.push(
    getDocs(collection(firestore, 'businessAdvisors'))
      .then(s => s.docs.forEach(d => add(d, 'Moderator')))
      .catch(() => null)
  );
  tasks.push(
    getDocs(collection(firestore, 'advisors'))
      .then(s => s.docs.forEach(d => add(d, 'Moderator')))
      .catch(() => null)
  );
  tasks.push(
    getDocs(collection(firestore, 'coaches')).then(s => s.docs.forEach(d => add(d, 'Coach')))
  );
  tasks.push(
    getDocs(collection(firestore, 'alumni')).then(s => s.docs.forEach(d => add(d, 'Alumni')))
  );
  if (includeClients) {
    tasks.push(
      getDocs(collection(firestore, 'clients')).then(s => s.docs.forEach(d => add(d, 'Client')))
    );
  }

  await Promise.all(tasks);
  return Array.from(people.values()).map(p => ({
    email: p.email,
    name: p.name,
    uid: p.uid,
    roles: Array.from(p.roles),
  }));
}
